import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initCallTracking } from "./lib/callTracking";

initCallTracking();

createRoot(document.getElementById("root")!).render(<App />);
